import React from 'react';
import TestimonialCarouselNew from './TestimonialCarouselNew';

const TestimonialsNew = () => {
  return (
    <section className="py-6 md:py-12 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-5xl font-serif font-bold text-primary mb-6">
            Client Stories
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Hear from those who have experienced the timeless elegance and superior craftsmanship of our kilts.
          </p>
        </div>
        
        <TestimonialCarouselNew />
      </div>
    </section>
  );
};

export default TestimonialsNew;
